import { Badge, styled, CircularProgress, Tooltip } from "@mui/material";
import { useConnection } from "../contexts/ConnectionContext";
import { useTheme } from "@mui/material/styles";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 2,
    top: 2,
    border: `1px solid ${theme.palette.background.paper}`,
    padding: "0 2px",
  },
}));

const ConnectionStatusIndicator = () => {
  const theme = useTheme();
  const { status, connection } = useConnection();

  const getStatusColor = () => {
    switch (status) {
      case "connected":
        return theme.palette.success.main;
      case "connecting":
        return theme.palette.warning.main;
      case "disconnected":
        return theme.palette.error.main;
      default:
        return theme.palette.grey[500];
    }
  };

  const getStatusTooltip = () => {
    switch (status) {
      case "connected":
        return "Connected to chat server";
      case "connecting":
        return "Connecting to chat server...";
      case "disconnected":
        return connection?.state === "Reconnecting"
          ? "Reconnecting to chat server..."
          : "Disconnected from chat server";
      default:
        return "Connection status unknown";
    }
  };

  return (
    <Tooltip title={getStatusTooltip()} arrow>
      <StyledBadge
        color="default"
        variant="dot"
        overlap="circular"
        sx={{
          "& .MuiBadge-badge": {
            backgroundColor: getStatusColor(),
            color: getStatusColor(),
            boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
          },
        }}
      >
        {status === "connecting" ? (
          <CircularProgress
            size={24}
            thickness={4}
            sx={{ color: theme.palette.warning.main }}
          />
        ) : (
          <div
            style={{
              width: 12,
              height: 24,
              borderRadius: "50%",
              backgroundColor: theme.palette.background.paper,
            }}
          />
        )}
      </StyledBadge>
    </Tooltip>
  );
};

export default ConnectionStatusIndicator;
